import { render, staticRenderFns } from "./SoSelect.vue?vue&type=template&id=dd36eada"
import script from "./SoSelect.vue?vue&type=script&lang=js"
export * from "./SoSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports